import { useAuth } from '@/core/auth';
import { SidebarLayout } from '@/core/layouts/sidebar-layout';
import { createGmnRoutes } from '@/core/router';

export function GmnLayout() {
  const { user } = useAuth();
  const routes = createGmnRoutes(user);

  return <SidebarLayout routes={routes} mainClassName="flex-1 overflow-y-auto" />;
}
